<template>
  <wv-steak-house-default-section :section="section" :menu="menu" section-modifier="steak"
                                  class="menu--section-wv_steak_house_steak"
                                  :class="{'menu--section-prime_ribs': isPrimeRibsSection}"></wv-steak-house-default-section>
</template>

<script lang="ts">
/**
 * Custom component for WV Steak House steak section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <WVSteakHouseSteakSection> adds customizations for the WV Steak House steak menu section.
 *
 *  2025-04-08 (1.1.0) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <WVSteakHouseSteakSection>.
 *    - Remove "visual_" and "textual_" prefixes from class names in <WVSteakHouseSteakSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import WvSteakHouseDefaultSection from "./WvSteakHouseDefaultSection.vue";

export default defineComponent({
  name: 'WvSteakHouseSteakSection',
  components: {WvSteakHouseDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
  computed: {
    isPrimeRibsSection() {
      return /(^|\s)prime ribs?(\s|$)/i.test(this.section.ms_title);
    }
  }
})
</script>

<style scoped>
.menu--section-wv_steak_house_steak,
.visual_menu--container-landscape .menu--section-wv_steak_house_steak {
  padding-bottom: 0;
}

.menu--section-wv_steak_house_steak:deep(.menu--item_subgroup:nth-child(1)::before),
.visual_menu--section.menu--section-wv_steak_house_steak:deep(.menu--item_subgroup:nth-child(2)::before),
.textual_menu--section.menu--section-wv_steak_house_steak:deep(.viewport + .viewport .menu--item_subgroup:nth-child(1)::before) {
  content: '';
  position: absolute;
  top: 1em;
  right: 11em;
  width: 5em;
  height: 5em;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(/library/images/menu-tags/tag-niman-ranch-128.png);
}

.menu--section-wv_steak_house_steak:deep(.menu--item_subgroup:nth-child(1)::before) {
  right: 13em;
  top: 2.5em;
}

html .textual_menu--section.menu--section-wv_steak_house_steak:deep(.viewport + .viewport .menu--item_subgroup:nth-child(1)::before) {
  right: 11.9em;
}

.textual_menu--section.menu--section-wv_steak_house_steak:deep(.viewport + .viewport + .viewport .menu--item_subgroup:nth-child(1)::before) {
  display: none;
}

.visual_menu--section.menu--section-wv_steak_house_steak:deep(.menu--item_subgroup:nth-child(2)::before),
.textual_menu--section.menu--section-wv_steak_house_steak:deep(.viewport + .viewport .menu--item_subgroup:nth-child(1)::before) {
  left: auto;
  right: 9.4em;
  width: 8em;
  height: 8em;
  background-image: url(/library/images/menu-tags/tag-prime-128.png);
}

.menu--section-prime_ribs:deep(.menu--item_subgroup:nth-child(1)::before) {
  right: 13em;
  top: -1em;
  background-image: url(/library/images/menu-tags/tag-certified-angus-beef-128.png);
}

@media (max-width: 768px) {
  .textual_menu--section.menu--section-wv_steak_house_steak:deep(.menu--item_subgroup:nth-child(1)::before) {
    right: 7em;
    width: 4em;
    height: 4em;
  }

  html .textual_menu--section.menu--section-wv_steak_house_steak:deep(.viewport + .viewport .menu--item_subgroup:nth-child(1)::before) {
    right: 6.3em;
    width: 6em;
    height: 6em;
  }
}

/*@media (max-width: 600px) {
  .menu--section-wv_steak_house_steak.textual_menu--section:deep(.viewport .menu--item_subgroup::before) {
    right: 3em;
    top: 4em;
    width: 4em;
    height: 4em;
  }

  .menu--section-wv_steak_house_steak.textual_menu--section:deep(.viewport + .viewport .menu--item_subgroup::before) {
    right: 2.5em;
    top: 7em;
    width: 6em;
    height: 6em;
  }

  .textual_menu--section.menu--section-wv_steak_house_steak:deep(.menu--item_title) {
    grid-template-columns: 3em max-content;
  }

  .textual_menu--section.menu--section-wv_steak_house_steak:deep(.menu--item_description) {
    grid-column: 1 / -1;
    padding-bottom: 0.35em;
    padding-left: 3.5em;
  }
}*/

@media (max-width: 625px) {
  .menu--section-wv_steak_house_steak.textual_menu--section:deep(.viewport .menu--item_subgroup::before) {
    display: none;
  }
}

.menu--section-wv_steak_house_steak:deep(.menu_version--container) {
  bottom: -7em;
}

.menu--section-wv_steak_house_steak:deep(.menu--section_subgroup_title) {
  margin-bottom: 0.5em;
}

.menu--section-wv_steak_house_steak:deep(.menu--item_subgroup) {
  grid-gap: 0.25em;
  margin-top: 1em;
  position: relative;
}
</style>